import { ArgumentOutOfRangeException } from "../../shared/index.js";
import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const rangeParallel = (start, count) => {
    if (start < 0 || (start + count - 1) > Number.MAX_SAFE_INTEGER) {
        throw new ArgumentOutOfRangeException("start");
    }
    const generator = () => {
        const items = [];
        const maxI = start + count;
        for (let i = start; i < maxI; i++) {
            items.push(Promise.resolve(i));
        }
        return items;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 1,
    });
};
